// extracted by mini-css-extract-plugin
module.exports = {"extension":"MaterialExtension_extension__qUIaE"};